import React from 'react'
import TextField from '@mui/material/TextField'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker'
import { FormControl, FormHelperText } from '@mui/material'
import { Controller } from 'react-hook-form'
import moment from 'moment'

export const makeLocalAppearUTC = (value: any, type = 'date') => {
  if (moment(value).isValid()) {
    const offset = moment(value).utcOffset()
    //.toISOString()
    return moment(value).format(
      type === 'datetime' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD',
    )
  }
}

export const localToUTC = (dateTime: any) => {
  if (moment(dateTime).isValid()) {
    const offset = moment(dateTime).utcOffset()
    const date = moment(dateTime).format('YYYY-MM-DD')
    return date
  }
}

export default function DatePicker(props: any) {
  const { size, name, form, label, type, readonly } = props

  return (
    <Controller
      control={form.control}
      name={name}
      render={({
        field: { onChange, ref, value, ...rest },
        fieldState: { error, ...state },
      }: any) => {
        return (
          <FormControl fullWidth>
            <LocalizationProvider
              sx={{ width: '100%' }}
              dateAdapter={AdapterDayjs}
            >
              <MUIDatePicker
                inputRef={ref}
                label={label}
                inputFormat={readonly ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'}
                renderInput={(params) => (
                  <TextField
                    size={size || 'small'}
                    {...params}
                    disabled={readonly}
                    error={error}
                  />
                )}
                {...rest}
                value={value ? makeLocalAppearUTC(value, type) : null}
                onChange={(value: any) =>
                  onChange({
                    target: { value: value?.$d ? localToUTC(value?.$d) : '' },
                  })
                }
                readOnly={readonly}
              />
            </LocalizationProvider>

            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )
      }}
    />
  )
}
